import { createContext, useContext, useEffect, useState, useCallback } from "react";
import adminApi from "@/lib/adminApi";

const AdminAuthContext = createContext(null);

export const AdminAuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("jk_admin_token");
    if (!token) {
      setAdmin(null);
      setLoading(false);
      return;
    }
    try {
      const { data } = await adminApi.get("/admin/me");
      setAdmin(data);
    } catch {
      localStorage.removeItem("jk_admin_token");
      setAdmin(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = (token, email) => {
    localStorage.setItem("jk_admin_token", token);
    setAdmin({ email });
  };

  const logout = () => {
    localStorage.removeItem("jk_admin_token");
    setAdmin(null);
  };

  return (
    <AdminAuthContext.Provider value={{ admin, loading, login, logout, refresh }}>
      {children}
    </AdminAuthContext.Provider>
  );
};

export const useAdminAuth = () => useContext(AdminAuthContext);
